import Layout from '../../components/Layout';
import GreenHouseIFrame from '../../components/GreenHouseIFrame';
import greenHouse from '../../utils/greenHouse';

const JobPost = () => (
  <Layout meta={greenHouse.meta} pageTitle="Careers - FabFitFun">
    <GreenHouseIFrame page={greenHouse.pages.JOB_POST} />
  </Layout>
);

export default JobPost;
